import {
    DivesApiFactory,
    DiveSharingTokenDto,
    SharedDivesApiFactory,
    DiveAndMixesEditDTO
} from '../api';
import { AuthLogic } from '../auth/AuthLogic';

export class DiveService {
    public static instance: DiveService;
    public static getInstance(): DiveService {
        if (DiveService.instance == undefined) {
            DiveService.instance = new DiveService();
        }

        return DiveService.instance;
    }

    public async loadDives() {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesGet();

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async loadSharedDives() {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await SharedDivesApiFactory({
                accessToken: token
            }).apiSharedDivesGet();

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async loadDiveData(diveId: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesByIdGet(diveId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async loadSharedDiveData(diveId: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await SharedDivesApiFactory({
                accessToken: token
            }).apiSharedDivesByDiveIdGet(diveId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async getShareDiveTokenByDiveId(
        diveId: string
    ): Promise<DiveSharingTokenDto | undefined> {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesByIdSharingTokensPost(diveId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return undefined;
        }
    }

    public async removeDiveByDiveId(diveId: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesByIdDelete(diveId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async removeSharedDiveByDiveId(diveId: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await SharedDivesApiFactory({
                accessToken: token
            }).apiSharedDivesByDiveIdDelete(diveId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async newDiveComment(diveId: string, comment: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesByIdCommentsPost(diveId, { comment });

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async submitDives(diveId: string, data: DiveAndMixesEditDTO, updateExistsDive: boolean = false) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            // editing exists dive
            if (updateExistsDive) {
                const responseUpdated = await DivesApiFactory({
                    accessToken: token
                }).apiDivesByIdPut(diveId, data);

                return responseUpdated;
            }

            // confirm new dive
            const responseCreated = await DivesApiFactory({
                accessToken: token
            }).apiDivesByIdPost(diveId, data);

            return responseCreated;

        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    // tslint:disable-next-line:no-any
    public async createDivesFromFile(file: any) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await DivesApiFactory({
                accessToken: token
            }).apiDivesPost(file);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async createSharedDive(tokenId: string) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await SharedDivesApiFactory({
                accessToken: token
            }).apiSharedDivesBySharingTokenPost(tokenId);

            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/DiveService.ts